import React from 'react';
import { motion } from "framer-motion";
import { fadeIn } from '../utils/variants';

// Bandeau de prix, juste avant « Get in touch » : quelqu'un qui vient de
// regarder les projets se demande combien ça coûte. Répondre ici évite le
// mail « c'est quoi vos tarifs ? » — et écarte ceux qui ne sont pas dans le
// budget avant qu'ils écrivent.
const Pricing = () => {
  return (
    <section className='section pt-0' id='pricing'>
      <div className='container mx-auto'>
        <motion.div
          variants={fadeIn("up", 0.2)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.2 }}
          className='card px-6 py-10 sm:px-10 sm:py-12 text-center'>

          <span className='badge-pill mb-5'><span className='dot' />Pricing</span>

          <h2 className='h2'>
            A website from{' '}
            <span className='text-accent underline decoration-accent/50 decoration-2 underline-offset-8'>
              599 €
            </span>{' '}
            per project
          </h2>

          <p className='text-gray-400 max-w-lg mx-auto'>
            Payment can be split in two. Hosting and domain name stay in your own
            name — you own the site.
          </p>

          <a href='#contact' className='btn px-6 py-3 mt-8 inline-flex'>
            Start a project
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Pricing;
